export const INNOVATION_ROUTES = {
  HOME: "/innovation",
  EXPERIMENT_SETUP: "/innovation/experiment-setup",
  EXPERIMENT_REPORT: "/innovation/experiment-report",
  PREVIEW_CUSTOMER: "/innovation/preview/customer/:id",
  PREVIEW_INTERNAL: "/innovation/preview/internal/:id",
} as const;
